const CategorySangPageORGEN = [
    {
        ID: 60,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-2.jpg",
        CategoryID: 1001,
        Details: "Premium Coffee Cream",
        CompanyName: "Abarkuh"
    },
    {
        ID: 138,
        Name: "Marble",
        ImageURL: "image/Stone/4-35.jpeg",
        CategoryID: 1002,
        Details: "Black 40 Length",
        CompanyName: "Najafabad"
    },
    {
        ID: 145,
        Name: "Granite",
        ImageURL: "image/Stone/2-5.jpg",
        CategoryID: 1003,
        Details: "Nahbandan",
        CompanyName: "_"
    },
    {
        ID: 64,
        Name: "Marble",
        ImageURL: "image/new-cat-2-6.jpeg",
        CategoryID: 1004,
        Details: "",
        CompanyName: "_"
    },
]
export default CategorySangPageORGEN;